export default (function ($) {

    var _instance = {}

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {

            $('a#print').each(function () {
                $(this).on('click', function (e) {
                    e.preventDefault();
                    window.print();
                })

            })
        });
    };

    return _instance;

})(jQuery)